import React, { useState, useEffect } from "react";
import "./styles/liegedevs.css";
import {
  SiJavascript,
  SiNodedotjs,
  SiReact,
  SiPostgresql,
  SiPython,
  SiPytorch,
  SiExpress,
  SiTailwindcss,
  SiCss3,
  SiMongoose,
  SiMongodb
} from "react-icons/si";

const services = [
  {
    title: "Web Development",
    desc: "build fast, responsive, and scalable websites tailored to real business needs. From clean landing pages to full-stack web applications, every site is engineered for performance, usability, and long-term maintainability.",
    src: "/web.png",
  },
  {
    title: "App Development",
    desc: "develop intuitive and reliable applications designed for real-world use. Whether it’s a web app or a mobile-first solution, the focus is on clean architecture, smooth user experience, and scalable functionality.",
    src: "/app.png",
  },
  {
    title: "Digital Marketing",
    desc: "help businesses grow their online presence through data-driven digital strategies. From SEO-friendly website structure to performance-focused campaigns, the goal is consistent visibility, engagement, and measurable results.",
    src: "/digital.png",
  },
  {
    title: "Email Marketing",
    desc: "design and implement email campaigns that actually convert. From transactional emails to automated marketing flows, each campaign is built to be reliable, deliverable, and aligned with user behavior.",
    src: "/email.png",
  },
];

const techIcons = {
  JavaScript: <SiJavascript />,
  "Node.js": <SiNodedotjs />,
  React: <SiReact />,
  PostgreSQL: <SiPostgresql />,
  Python: <SiPython />,
  PyTorch: <SiPytorch />,
  Express: <SiExpress />,
  Mongoose: <SiMongoose />,
  Css: <SiCss3 />,
  TailWindCss: <SiTailwindcss />,
  MongoDB: <SiMongodb />
};

const projects = [
  {
    image: "/projects/project-1.png",
    title: "Hotel-Celebrations-Pride",
    description: [
      "Hotel Celebrations Pride is a production-ready hospitality website built to digitally represent a hotel and event venue with a strong focus on clarity, performance, and usability. The site functions as an informational and engagement layer, presenting accommodation options, amenities, dining, and event facilities through a structured, section-driven layout.",
      "From a technical standpoint, the website emphasizes clean content architecture and predictable navigation flows, allowing users to move efficiently between discovery (rooms, services, events) and action (contact or booking inquiry). Visual elements are used purposefully to support content hierarchy without overwhelming the interface.",
    ],
    details: [
    "Key concepts behind the app include:",
    "Visual-first layout: A grid of room options that reacts to hover interactions, drawing attention to choices.",
    "Adaptive responsiveness: Interfaces that adjust for phones, tablets, and desktops — including mobile-specific controls like a floating call-to-action for bookings.",
    "User interaction flows: Smooth animations and interactive feedback that make the user experience engaging and intuitive.",
    "Practical cruise-control for UI: Things like image sliders and a quick booking form help bridge the gap between browsing and action.",
    ],
    tech: ["React", "Node.js", "Css", "TailWindCss", "MongoDB"],
    link: "#",
    github: "#",
  },
  {
    image: "/projects/project-2.png",
    title: "Dr-Physio-Clinic-Website",
    description: [
    "DrPhysioClinic-Physio-Appointment-Website is a full-stack web application that is built with a traditional backend server that delivers dynamic pages and supports form interactions, giving patients a practical way to learn about services, view testimonials, and book physiotherapy appointments all in one place.",
    "Server-Rendered Web Application built using a traditional backend-driven architecture rather than a client-heavy SPA.",
    "Pages are rendered server-side, improving initial load performance and SEO.",
    "MVC-Style Structure",
    "Separation between routing, business logic, and presentation using templated views."],    
    details: [
    "Instead of being a static brochure site, this project goes further by enabling real interaction:",
    "Clinic Information Pages – Visitors can read about the clinic’s mission and services.",
    "Testimonials Display – Shows real feedback from patients to build trust.",
    "Contact & Appointment Form – Patients can send inquiries or request an appointment directly through the site.",
    "Server-Side Rendering – The site delivers dynamic HTML with EJS templates based on user interaction and data.",
    "Email Facilitation – Outgoing communication such as appointment confirmations is handled via Nodemailer.",
    "Overall, it strikes a balance between informational content and interactive healthcare scheduling, making clinic access easier and more modern.",
    ],    
    tech: ["JavaScript", "Express", "MongoDB", "Css"],
    link: "#",
    github: "#",
  },
  {
    image: "/projects/project-3.png",
    title: "Built-Together-Foundation",
    description: [
    "Built Together Foundation is a purpose-driven, single-page website created for a non-profit organization focused on restoration, healing, and empowerment. The site serves as a digital home for the foundation’s mission, offering visitors clarity, emotional connection, and a direct way to support the cause.",
    "Rather than being content-heavy, the website is intentionally lightweight and focused — guiding users through the foundation’s values while making it easy to take meaningful action through donations.",
    ],      
    details: [
    "Key concepts behind the app include:",

    "Mission-Driven Content Flow - Clearly presents the foundation’s values and long-term vision, guiding visitors through a narrative of renewal, restoration, and hope.",
    "Integrated Donation Experience - Includes an embedded DonorBox widget, allowing supporters to contribute securely without leaving the site.",
    "Responsive, Mobile-First Layout - Designed to adapt smoothly across desktops, tablets, and mobile devices, ensuring consistent usability on all screen sizes.",
    "Visually Engaging Design - Uses modern CSS techniques such as parallax effects, thoughtful typography, and balanced spacing to create a professional and emotionally resonant experience.",
    ],    
    tech: ["JavaScript", "Css", "TailWindCss"],
    link: "#",
    github: "#",
  },
  {
  image: "/projects/project-4.png",
  title: "Ebenezer-Inn-Website",
  description: [
    "Ebenezer Inn is a hospitality website designed to present a welcoming and professional online presence for a serviced accommodation property. The site highlights room offerings, amenities, and location details while making it easy for visitors to understand what the property offers and how to get in touch.",
    "Built as a lightweight, responsive site, it ensures a smooth browsing experience across desktops, tablets, and mobile devices, making it suitable for both casual visitors and travelers actively planning a stay."
  ],    
  details: [
  "Architecture & Structure",
  "The site is built as a lightweight static website, prioritizing fast load times, reliability, and ease of maintenance.",
  "Single-Page / Section-Based Layout - Content is organized into clearly defined sections (hero, rooms, amenities, gallery, contact), reducing navigation friction and improving user flow.",
  "Custom styling without heavy frameworks.",
  "Responsive layouts using media queries.",
  "Typography-focused design using web fonts for a premium hospitality feel."


  ],   
  tech: ["JavaScript", "Css", "TailWindCss"],
  link: "#",
  github: "#",
  },
  {
  image: "/projects/project-6.png",
  title: "TrekApp-Trekking-Website ",
  description: [
  "TrekApp is a full-stack web application designed to manage and deliver trekking and adventure tour experiences through a modern, scalable web interface.",
  "The platform supports end-to-end user interaction — from discovering trekking routes to booking tours and sharing post-experience feedback.",
  "The application is built with a clear separation between frontend and backend responsibilities, focusing on secure authentication, dynamic content rendering, and reliable data persistence."
  ],      
  details: [
  "Core Functionality:",
  "Tour Discovery System - Users can browse a curated catalog of trekking routes with varying difficulty levels and destinations.",
  "User Authentication & Authorization - Secure user registration and login implemented using JWT-based authentication, enabling personalized user sessions and protected routes..",
  "Booking Workflow - Users can book trekking tours through a streamlined booking flow with confirmation handling and stored booking history.",
  "Review & Feedback Module - Authenticated users can submit and view tour reviews, enabling community-driven insights and experience sharing.",
  "Responsive UI - The frontend adapts seamlessly across desktop and mobile devices, ensuring accessibility for users on the go.",
  ],     
  tech: ["MongoDb", "Express", "React", "Node.js", "Css", "TailWindCss", "Mongoose"],
  link: "#",
  github: "#",
  },
];

function LiegeTech() {
    const [openProject, setOpenProject] = useState(null);
  
    // ESC key closes modal
    useEffect(() => {
      const handleEsc = (e) => {
        if (e.key === "Escape") setOpenProject(null);
      };
      window.addEventListener("keydown", handleEsc);
      return () => window.removeEventListener("keydown", handleEsc);
    }, []);
  
  return (
    <section className="liege">
      <section className="liege-section">
        <span className="liege-label">START UP</span>

        <h2 className="liege-headline">
          LIEGE <span>TECHNOLOGIES</span>
        </h2>
      </section>

      {/* HERO */}
      <header className="liege-hero">
        <span className="hero-badge">Web Design • Development • Support</span>
        <h1>
          Building <span>high-impact</span> websites <br /> for modern businesses
        </h1>
        <p>
          Liege Developers crafts fast, elegant, and scalable websites that help
          brands grow online.
        </p>
      </header>

      <section className="services-section">
        <span className="services-label">Services</span>
        <h2 className="services-title">Our Features & Services</h2>

        <div className="services-grid">
          {services.map((s, i) => (
            <div key={i} className="services-card">
              <div className="service-icon">
                <img src={s.src} alt={s.title} />
              </div>              
              <h3>{s.title}</h3>
              <p>
                <strong>Liege Technologies</strong> {s.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICES */}
      <section className="liege-services">
        <h2>What We Do ?</h2>

        <div className="service-grid">
          <div className="service-card">
            <h3>Web Design</h3>
            <p>
              Clean, brand-focused designs built for clarity, trust, and
              conversion.
            </p>
          </div>

          <div className="service-card">
            <h3>Web Development</h3>
            <p>
              Modern, responsive websites engineered for performance and
              scalability.
            </p>
          </div>

          <div className="service-card">
            <h3>Maintenance & Hosting</h3>
            <p>
              Reliable hosting, updates, and long-term support so your site never
              breaks.
            </p>
          </div>
        </div>
      </section>

     {/* CLIENTS */}
      <section className="clients-section">
        <h2>Trusted by Amazing Clients</h2>
        <p>Brands and businesses I’ve helped grow online</p>

        <div className="logo-slider premium">
          <div className="logo-track">

            {/* Logo Set */}
            {["icon1.png","icon2.png","icon3.png","icon4.png","icon5-white.png"].map((logo, i) => (
              <div className="logo-item" key={i}>
                <div className="logo-glass">
                  <img src={`/${logo}`} alt={`Client ${i + 1}`} />
                </div>
              </div>
            ))}

            {/* Duplicate Set for Seamless Loop */}
            {["icon1.png","icon2.png","icon3.png","icon4.png","icon5-white.png"].map((logo, i) => (
              <div className="logo-item" key={`dup-${i}`}>
                <div className="logo-glass">
                  <img src={`/${logo}`} alt={`Client ${i + 1}`} />
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      <div className="clients-grid">
        {projects.map((proj, index) => (
          <div
            key={index}
            className="project-card"
            style={{ animationDelay: `${index * 0.2}s` }}
            onClick={() => setOpenProject(proj)}
          >
            {/* Badge */}
            {proj.type === "backend" && (
              <span className="project-badge backend">Backend</span>
            )}

            {/* Image */}
            {proj.image ? (
              <img src={proj.image} alt={proj.title} />
            ) : (
              <div className="project-placeholder">
                <span className="placeholder-icon">⚙️</span>
                <p>Backend System</p>
              </div>
            )}
            <h3>{proj.title}</h3>

            <p>
              {proj.description.map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </p>

            <div className="tech-tags">
              {proj.tech.map((t, i) => (
                <span key={i} className="tag">
                  {techIcons[t] && (
                    <span className="tag-icon">{techIcons[t]}</span>
                  )}
                  {t}
                </span>
              ))}
            </div>

            <a
              href={proj.link}
              className="project-link"
              onClick={(e) => e.stopPropagation()} // Prevent triggering modal
              target="_blank"
              rel="noopener noreferrer"
            >
              View Project →
            </a>
          </div>
        ))}
      </div>

      {/* PROCESS */}
      <section className="liege-process">
        <h2>How It Works ?</h2>

        <div className="process-steps">
          <div className="process-step">
            <span>01</span>
            <h3>Consultation</h3>
            <p>Understanding your goals, audience, and business needs.</p>
          </div>

          <div className="process-step">
            <span>02</span>
            <h3>Design</h3>
            <p>Wireframes and layouts aligned with your brand identity.</p>
          </div>

          <div className="process-step">
            <span>03</span>
            <h3>Development</h3>
            <p>Fast, responsive, SEO-friendly implementation.</p>
          </div>

          <div className="process-step">
            <span>04</span>
            <h3>Launch & Support</h3>
            <p>Deployment, monitoring, and long-term maintenance.</p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="liege-cta">
        <h2>Let’s build something great</h2>
        <p>
          Need a website that actually works for your business?
        </p>
        <a href="/contact" className="cta-button">Start a Project</a>
      </section>

      <section className="construction-note">
        <a
          href="https://liege.studio/"
          target="_blank"
          rel="noopener noreferrer"
          className="website-link"
        >
          Official website
        </a>{" "}
        is currently under construction. Updates coming soon.
      </section>

      {/* === PROJECT MODAL === */}
      {openProject && (
        <>
          <div className="modal-backdrop" onClick={() => setOpenProject(null)} />

          <div className="modal">
            <button className="modal-close" onClick={() => setOpenProject(null)}>
              ✕
            </button>

            <h2>{openProject.title}</h2>

            <p className="modal-description">
              {openProject.details.map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                  <br />
                </span>
              ))}
            </p>

            <h3>Tech Used</h3>
            <div className="modal-tech">
              {openProject.tech.map((t, i) => (
                <span key={i} className="tag">
                  {techIcons[t]} {t}
                </span>
              ))}
            </div>

            <div className="modal-buttons">
              <a href={openProject.link} target="_blank" rel="noopener noreferrer">
                Live Demo
              </a>
              <a href={openProject.github} target="_blank" rel="noopener noreferrer">
                GitHub
              </a>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default LiegeTech;